module.exports = "<div class=\"scroll-fix\" scroll-fix=\"\"><ng-include src=\"'./common/templates/navbar.jade'\"></ng-include><div class=\"animate-wrapper\"><ui-view class=\"animate\"></ui-view><div class=\"clearfix\"></div></div><ng-include src=\"'./common/templates/tutorial.jade'\"></ng-include><ng-include src=\"'./common/templates/preview.jade'\"></ng-include></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/common/templates/layout.jade
// module id = 288
// module chunks = 0